import React, { useEffect, useState } from "react";
import { Col, Row, Button, Pagination } from "rsuite";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEdit } from "@fortawesome/free-solid-svg-icons";
import {
	apiAcceptall,
	apiUpdateMarginBrainDataRec,
	apiUpdateMarginBrainDataRecitem,
} from "../../react-query/api/index";
import { whiteLabelConstansts } from "../../utils/constants";
import {
	DataPoint,
	ItemLevelData,
	ExtendedRows,
	DivisionTableProps,
} from "../../models/whiteLabelTableModel";
import { numberFormatter } from "../../utils/formatter";

const ruleList = [
	{
		label: "0%",
		value: 0,
	},
	{
		label: "5%",
		value: 0.05,
	},
	{
		label: "10%",
		value: 0.1,
	},
	{
		label: "15%",
		value: 0.15,
	},
	{
		label: "20%",
		value: 0.2,
	},
	{
		label: "25%",
		value: 0.25,
	},
	{
		label: "30%",
		value: 0.3,
	},
	{
		label: "35%",
		value: 0.35,
	},
];

const DivisionTable: React.FC<DivisionTableProps> = ({
	filterExpansion,
	data,
	setUpdatepopup,
	setItemidpopup,
	setDivisionpopup,
	setWeek,
	handleRecAccept,
	handleBCISubmit,
	fetchDivisionLevelData,
	fetchExpandedLevelData,
	itemLevelData,
	extendedRows,
	setItemLevelData,
	setExpandedData,
	expandedData,
	setExtendedRows,
	setClickedItem,
	currentPage,
	handlePageChange,
	setgraphLevelData,
	setMainData
}) => {
	useEffect(() => {
		setExpandedRow(null);
		setItemExpanded({});
		setColumns([
			"Product Type",
			"Cases/year (prior 52 weeks)",
			"Revenue/year (prior 52 weeks)",
			"Loaded Opportunity($)",
			"Status",
		]);
	}, [currentPage]);

	const { EXPANDED_COLUMNS, COLLAPSED_COLUMNS, COMMON_COLUMNS } =
		whiteLabelConstansts;
	const [fontSize, setFontSize] = React.useState<string>("0.85vw");
	const [columns, setColumns] = React.useState<string[]>([
		"Product Type",
		"Cases/year (prior 52 weeks)",
		"Revenue/year (prior 52 weeks)",
		"Loaded Opportunity($)",
		"Status",
	]);
	const [ruleType, setRuleType] = useState<string>("Above");
	const [expandedRow, setExpandedRow] = React.useState<number | null>(null);
	// const [expandedData, setExpandedData] = React.useState<{
	// 	[key: number]: any[];
	// }>({});
	const [itemExpanded, setItemExpanded] = React.useState<{
		[key: number]: boolean;
	}>({});

	const headerStyle = {
		backgroundColor: "white",
		color: "black",
		border: "1px solid #bebebe",
		borderBottom: "2px solid rgb(117, 189, 8)",
		padding: "0.5vw",
	};
	const columnStyle = {
		color: "black",
		borderRight: "0.1px solid #bebebe",
		borderBottom: "0.1px solid #bebebe",
		innerHeight: "36px",
	};

	const thousands = (value: number) =>
		`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	const handleIconClick = async (productType: string, index: number) => {
		const isAnyDivOpened = Object.values(itemExpanded).some(
			(item: boolean) => item === true
		);
		const isAllEdited = expandedData[index]?.some(
			(item: any) => item?.isEdited === true
		);
		if (expandedRow !== index) {
			setExpandedRow(index);
			if (isAllEdited) {
				setColumns(isAnyDivOpened ? EXPANDED_COLUMNS : COMMON_COLUMNS);
			} else {
				setColumns(isAnyDivOpened ? EXPANDED_COLUMNS : COMMON_COLUMNS);
				try {
					await fetchExpandedLevelData(productType, index);
				} catch (error) {
					console.error("Error fetching data:", error);
				}
			}
		} else {
			setExpandedRow(null);
			setColumns(COLLAPSED_COLUMNS);
		}
	};

	const handleEditClick =
		(fetchedIndex: number, extIndex: number, index: number) => (e: any) => {
			expandedData[index][fetchedIndex].numberOfEdits
				? (expandedData[index][fetchedIndex].numberOfEdits += 1)
				: (expandedData[index][fetchedIndex].numberOfEdits = 1);
			extendedRows[fetchedIndex][extIndex]["recOverride"] = {
				isEditable: true,
				value: extendedRows[fetchedIndex][extIndex]["recOverride"][
					"value"
				],
			};
			setExpandedData({ ...expandedData });
			setExtendedRows({ ...extendedRows });
		};
	const handleAcceptClick = async (
		parentIndex: number,
		fetchedIndex: number,
		extIndex: number
	) => {
		try {
			expandedData[parentIndex][fetchedIndex].isAccepted = true;
			setExpandedData({ ...expandedData });
			const extendedItem = extendedRows[fetchedIndex][extIndex];
			const payload = {
				data: [
					{
						itemid: extendedItem.itemId,
						divisionId: extendedItem.divisionId,
						recOverride: extendedItem.recOverride.isEditable
							? Number(extendedItem.recOverride.value)
							: Number(
								extendedRows[fetchedIndex][extIndex][
									"recOverride"
								].value
							),
						rule: 0.0,
						cfpMin: extendedItem.cfpMin,
						cfpMax: extendedItem.cfpMax,
						ruleType: "BELOW",
						isRecOverride: 1,
						fiscalWeek: Number(extendedItem.week),
						opportunity: extendedItem.recOverride.isEditable
							? Number(extendedItem.opportunity)
							: Number(
								extendedRows[fetchedIndex][extIndex][
								"opportunity"
								]
							),
					},
				],
			};

			await apiUpdateMarginBrainDataRec(payload);
			setUpdatepopup(true);
			setDivisionpopup(extendedItem.divisionId);
			setItemidpopup(extendedItem.itemId);
			setWeek(Number(extendedItem.week));
		} catch (error) {
			console.error("Error accepting item:", error);
			// Handle error appropriately (e.g., show toast notification)
		}
	};
	const handleAcceptAll = async (fetchedindex: any) => {
		setExpandedData({ ...expandedData });
		const payload = {
			data: [
				{
					itemid: fetchedindex.itemId,
					fiscalWeek: Number(fetchedindex.week),
				},
			],
		};
		await apiUpdateMarginBrainDataRecitem(payload);
	};
	const handlefullaccept = async () => {
		const payload = {
			data: [
				{
					fiscalWeek: 202203,
				},
			],
		};
		await apiAcceptall(payload);
	};

	const handlerule = (
		parentIndex: number, //Product Type
		fetchedIndex: number, //Item Type
		extIndex: number, //Division
		ruleType: string,
		percentage: number
	) => {
		let val = +percentage;
		const prevItemOpp = extendedRows[fetchedIndex][extIndex]["opportunity"];
		let totalOpport = expandedData[parentIndex][fetchedIndex].opportunity - extendedRows[fetchedIndex][extIndex]["opportunity"];
		extendedRows[fetchedIndex][extIndex]["opportunity"] = 0;
		const d = extendedRows[fetchedIndex][extIndex]
		if (ruleType !== "Above") {
			d.cfpMin =
				(1 - (Math.abs(val) - d.minThreshold)) *
				d.leadingPrice;
			if (d.cfpMin < 0) {
				d.cfpMin = 0;
			}
			d.cfpMax =
				(1 - (Math.abs(val) - d.maxThreshold)) *
				d.leadingPrice;
			if (d.cfpMax < 0) {
				d.cfpMax = 0;
			}
		} else {
			d.cfpMin =
				(1 + (Math.abs(val) + d.minThreshold)) *
				d.leadingPrice;
			if (d.cfpMin < 0) {
				d.cfpMin = 0;
			}
			d.cfpMax =
				(1 + (Math.abs(val) + d.maxThreshold)) *
				d.leadingPrice;
			if (d.cfpMax < 0) {
				d.cfpMax = 0;
			}
		}
		if (
			d.cfpMin <= d.followingPrice &&
			d.cfpMax >= d.followingPrice
		) {
			d.opportunity = 0;
		} else {
			d.opportunity =
				((d.cfpMin + d.cfpMax) / 2 - d.followingPrice) * d.volume;
		}
		d.recOverride.value =
			Math.round(((d.cfpMax + d.cfpMin) / 2) * 100) / 100;

		totalOpport += d.opportunity
		expandedData[parentIndex][fetchedIndex].opportunity = totalOpport;
		extendedRows[fetchedIndex][extIndex]["AvgPriceChange"] = (
			((extendedRows[fetchedIndex][extIndex]["recOverride"].value -
				extendedRows[fetchedIndex][extIndex]["followingPrice"]) /
				extendedRows[fetchedIndex][extIndex]["followingPrice"]) *
			100
		).toFixed(2);

		let recOverrideSum = 0,
			len: number = extendedRows[fetchedIndex].length,
			avgPriceChangeSum = 0;
		extendedRows[fetchedIndex].map((item) => {
			recOverrideSum += parseFloat(item.recOverride.value);
			avgPriceChangeSum += parseFloat(item.AvgPriceChange);
		});

		expandedData[parentIndex][fetchedIndex]["recOverride"] = (
			recOverrideSum / len
		).toFixed(2);
		expandedData[parentIndex][fetchedIndex]["avgPriceChange"] = (
			avgPriceChangeSum / len
		).toFixed(2);


		setgraphLevelData((prev: any) => {
			let selectedItem = prev?.data?.find((a: any) => a.divisionId === expandedData[parentIndex][fetchedIndex].divisionId)
			if (selectedItem) {
				selectedItem = expandedData[parentIndex][fetchedIndex];
			}
			return { ...prev }
		})

		setMainData((prev) => {
			prev[parentIndex].opportunity += d.opportunity - prevItemOpp;
			return prev;
		})

		// Update state
		setExpandedData({ ...expandedData });
		setExtendedRows({ ...extendedRows });
	};
	const handleChange =
		(
			parentIndex: number,
			fetchedIndex: number,
			extIndex: number,
			prevValue: number,
			fetchedItem: any
		) =>
			(e: any) => {
				const division = expandedData[parentIndex][fetchedIndex]
				const item = extendedRows[fetchedIndex][extIndex]
				let totalOpport = division.opportunity - item["opportunity"];


				item.recOverride.value = Number(e.target.value);

				let old = item.opportunity;
				item.opportunity = (Number(e.target.value) - item.followingPrice) * item.volume;

				division.opportunity += item.opportunity - old;

				division.recOverride = 0;
				extendedRows[fetchedIndex].forEach((d: any) => {
					if (d.recOverride.value) {
						division.recOverride +=
							d.recOverride.value;
					}
				});
				division.recOverride =
					Math.round(
						(division.recOverride /
							division.division) *
						10
					) / 10;
				totalOpport += division.opportunity;

				division.opportunity = totalOpport
				extendedRows[fetchedIndex][extIndex]["AvgPriceChange"] = (
					((extendedRows[fetchedIndex][extIndex]["recOverride"].value -
						extendedRows[fetchedIndex][extIndex]["followingPrice"]) /
						extendedRows[fetchedIndex][extIndex]["followingPrice"]) *
					100
				).toFixed(2);

				let recOverrideSum = 0,
					len: number = extendedRows[fetchedIndex].length,
					avgPriceChangeSum = 0;
				extendedRows[fetchedIndex].map((item) => {
					recOverrideSum += parseFloat(item.recOverride.value);
					avgPriceChangeSum += parseFloat(item.AvgPriceChange);
				});

				division["recOverride"] = (
					recOverrideSum / len
				).toFixed(2);
				division["avgPriceChange"] = (
					avgPriceChangeSum / len
				).toFixed(2);
				setMainData((prev) => {
					prev[parentIndex].opportunity += item.opportunity - old;
					return prev;
				})
				setExpandedData({ ...expandedData });
				setExtendedRows({ ...extendedRows });
				setgraphLevelData((prev: any) => {
					let selectedItem = prev?.data?.find((a: any) => a.divisionId === expandedData[parentIndex][fetchedIndex].divisionId)
					if (selectedItem) {
						selectedItem = expandedData[parentIndex][fetchedIndex];
					}
					return { ...prev }
				})
			};

	const handleItemIconClick = async (
		index: number,
		fetchedIndex: number,
		itemId: string,
		productType: string,
		editedItem: any
	) => {
		let expandedObj = { ...itemExpanded };
		expandedObj[fetchedIndex] = !expandedObj[fetchedIndex];
		let isDivisionExpanded = Object.values(expandedObj).includes(true);
		if (isDivisionExpanded) {
			if (!editedItem.hasOwnProperty("isEdited")) {
				setClickedItem(itemId);
				// Expand item row
				setColumns(EXPANDED_COLUMNS);
				await fetchDivisionLevelData(
					index,
					productType,
					itemId,
					fetchedIndex,
					{
						...expandedData,
					}
				);
			} else if (editedItem?.isEdited) {
				setColumns(EXPANDED_COLUMNS);
			}
		} else {
			// Collapse item row
			setColumns(COMMON_COLUMNS);
		}
		setItemExpanded((prev) => ({
			...prev,
			[fetchedIndex]: !prev[fetchedIndex],
		}));
	};

	return (
		<>
			<Row
				style={{
					height: "80%",
					width: "100%",
					marginLeft: "0px",
					marginRight: "0px",
				}}
			>
				<Col className="leftTable h-fu;" style={{ height: "100%" }}>
					<table className="fixed_header table-container">
						<tbody
							className="tbodyClass border-separate text-[0.75vw]"
						>
							<tr className="cursor-pointer text-[0.75vw]">
								{columns.map((d, index) => (
									<th
										key={index}
										className="table-header-text alignCenter itemTableHeader"
										style={headerStyle}
									>
										{d}
									</th>
								))}
							</tr>
							{data.map((item, index) => {
								const rowStyle = index % 2 == 0 ? "even" : "";
								return (
									<>
										<tr key={index} className={rowStyle}>
											{columns.includes(
												"Product Type"
											) && (
													<td style={columnStyle} className="table-cell-text alignCenter whitespace-nowrap">
														{expandedRow === index ? (
															<MinusRoundIcon
																style={{
																	marginRight:
																		"8px",
																	cursor: "pointer",
																}}
																onClick={() =>
																	handleIconClick(
																		item.productType,
																		index
																	)
																}
															/>
														) : (
															<PlusRoundIcon
																style={{
																	marginRight:
																		"8px",
																	cursor:
																		expandedRow ===
																			null
																			? "pointer"
																			: "not-allowed",
																	opacity:
																		expandedRow ===
																			null
																			? 1
																			: 0.5,
																}}
																onClick={() =>
																	expandedRow ===
																	null &&
																	handleIconClick(
																		item.productType,
																		index
																	)
																}
															/>
														)}
														{item.productType}
													</td>
												)}
											{columns.includes("Item Type") && (
												<td style={columnStyle}>
													{item.itemType || ""}
												</td>
											)}
											{columns.includes("Division") && (
												<td style={columnStyle}>
													{item.division || ""}
												</td>
											)}
											{columns.includes(
												"Cases/year (prior 52 weeks)"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														{numberFormatter(item.cases)}
													</td>
												)}
											{columns.includes(
												"Revenue/year (prior 52 weeks)"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														${numberFormatter(item.revenue)}
													</td>
												)}
											{columns.includes("Rule Type") && (
												<td
													className="table-cell-text alignCenter"
													style={columnStyle}
												>
													{ }
												</td>
											)}
											{columns.includes("Rule") && (
												<td
													className="table-cell-text alignCenter"
													style={columnStyle}
												>
													{ }
												</td>
											)}
											{columns.includes(
												"Current CFP"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														{ }
													</td>
												)}
											{columns.includes(
												"Variation from NBE"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														{ }
													</td>
												)}
											{columns.includes(
												"Avg. Recommended CFP"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														{ }
													</td>
												)}
											{columns.includes(
												"Avg. Recommended Price Change"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														{ }
													</td>
												)}

											{columns.includes(
												"Loaded Opportunity($)"
											) && (
													<td
														className="table-cell-text alignCenter"
														style={columnStyle}
													>
														$
														{numberFormatter(
															item.opportunity
														)}
													</td>
												)}
											{columns.includes("Status") && (
												<td
													className="table-cell-text alignCenter"
													style={columnStyle}
												>
													AC for {item.status} {item.status > 1 ? "items" : "item"}
												</td>
											)}
											{columns.includes("Actions") && (
												<td style={columnStyle}></td>
											)}
										</tr>
										{expandedRow === index &&
											expandedData[index] &&
											expandedData[index].map(
												(
													fetchedItem: {
														itemId: string;
														productType: string;
														division: any;
														cases: number;
														revenue: number;
														numberOfEdits?: number;
														isAccepted?: boolean;
														recOverride:
														| string
														| number
														| boolean
														| React.ReactElement<
															any,
															| string
															| React.JSXElementConstructor<any>
														>
														| Iterable<React.ReactNode>
														| React.ReactPortal
														| null
														| undefined;
														avgPriceChange:
														| number
														| undefined;
														opportunity: number;
														isEdited: boolean;
													},
													fetchedIndex: number
												) => {
													const numberOfAL =
														fetchedItem?.numberOfEdits ||
														0;
													const numberofAC =
														(fetchedItem.division ||
															0) - numberOfAL;
													return (
														<>
															<tr
																key={`${index}-${fetchedIndex}`}
															>
																{columns.includes(
																	"Product Type"
																) && (
																		<td
																			style={
																				columnStyle
																			}
																		>
																			{/* Leave this empty */}
																		</td>
																	)}
																{columns.includes(
																	"Item Type"
																) && (
																		<td
																			style={
																				columnStyle
																			}
																			className="table-cell-text whitespace-nowrap"
																		>
																			{itemExpanded[
																				fetchedIndex
																			] ? (
																				<MinusRoundIcon
																					style={{
																						marginRight:
																							"8px",
																						cursor: "pointer",
																					}}
																					onClick={() =>
																						handleItemIconClick(
																							index,
																							fetchedIndex,
																							fetchedItem.itemId,
																							fetchedItem.productType,
																							fetchedItem
																						)
																					}
																				/>
																			) : (
																				<PlusRoundIcon
																					style={{
																						marginRight:
																							"8px",
																						cursor: "pointer",
																					}}
																					onClick={() =>
																						handleItemIconClick(
																							index,
																							fetchedIndex,
																							fetchedItem.itemId,
																							fetchedItem.productType,
																							fetchedItem
																						)
																					}
																				/>
																			)}
																			{fetchedItem.itemId ||
																				""}
																		</td>
																	)}
																{columns.includes(
																	"Division"
																) && (
																		<td
																			style={
																				columnStyle
																			}
																			className="table-cell-text"
																		>
																			Total: {fetchedItem.division ||
																				""}
																		</td>
																	)}

																{columns.includes(
																	"Cases/year (prior 52 weeks)"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{numberFormatter(
																				fetchedItem.cases
																			)}
																		</td>
																	)}

																{columns.includes(
																	"Revenue/year (prior 52 weeks)"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			$
																			{numberFormatter(
																				fetchedItem.revenue
																			)}
																		</td>
																	)}

																{columns.includes(
																	"Rule Type"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{ }
																		</td>
																	)}

																{columns.includes(
																	"Rule"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{itemLevelData[
																				fetchedIndex
																			]
																				?.rule ||
																				""}
																		</td>
																	)}

																{columns.includes(
																	"Current CFP"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{ }
																		</td>
																	)}

																{columns.includes(
																	"Variation from NBE"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{ }
																		</td>
																	)}

																{columns.includes(
																	"Avg. Recommended CFP"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{
																				fetchedItem?.recOverride
																			}
																		</td>
																	)}
																<></>

																{columns.includes(
																	"Avg. Recommended Price Change"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{fetchedItem.avgPriceChange !==
																				undefined
																				? `${numberFormatter(
																					fetchedItem.avgPriceChange
																				)}%`
																				: ""}
																		</td>
																	)}

																{columns.includes(
																	"Loaded Opportunity($)"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			$
																			{numberFormatter(
																				fetchedItem.opportunity
																			)}
																		</td>
																	)}

																{columns.includes(
																	"Status"
																) && (
																		<td
																			className="table-cell-text alignCenter"
																			style={
																				columnStyle
																			}
																		>
																			{fetchedItem?.isAccepted
																				? `NR: ${fetchedItem.division ||
																				0
																				} Div's`
																				: (numberOfAL
																					? `AL :${numberOfAL}
																			Div's`
																					: "") +
																				(numberOfAL &&
																					numberofAC
																					? ", "
																					: "") +
																				(numberofAC
																					? `AC :${numberofAC}
																			Div's`
																					: "")}
																		</td>
																	)}

																{columns.includes(
																	"Actions"
																) && (
																		<td
																			style={
																				columnStyle
																			}
																		>
																			<Button
																				className="!bg-deloitteGreen w-[10vh] !text-white text-[0.8vw]"
																				onClick={() =>
																					handleAcceptAll(
																						fetchedItem
																					)
																				}
																			>
																				Accept
																				All
																			</Button>
																		</td>
																	)}
															</tr>
															{itemExpanded[
																fetchedIndex
															] &&
																extendedRows[
																fetchedIndex
																] &&
																extendedRows[
																	fetchedIndex
																].map(
																	(
																		extendedItem,
																		extIndex
																	) => (
																		<tr
																			key={`${fetchedIndex}-${extIndex}`}
																		>
																			{columns.includes(
																				"Product Type"
																			) && (
																					<td
																						style={
																							columnStyle
																						}
																					>
																						{/* Leave this empty */}
																					</td>
																				)}
																			{columns.includes(
																				"Item Type"
																			) && (
																					<td
																						style={
																							columnStyle
																						}
																					>
																						{/* Leave this empty */}
																					</td>
																				)}
																			{columns.includes(
																				"Division"
																			) && (
																					<td
																						style={
																							columnStyle
																						}
																						className="table-cell-text"
																					>
																						{extendedItem.division ||
																							""}
																					</td>
																				)}
																			{columns.includes(
																				"Cases/year (prior 52 weeks)"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{
																							extendedItem.volume
																						}
																					</td>
																				)}
																			{columns.includes(
																				"Revenue/year (prior 52 weeks)"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						$
																						{numberFormatter(
																							extendedItem.revenue
																						)}
																					</td>
																				)}
																			{columns.includes(
																				"Rule Type"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						<select
																							style={{
																								background:
																									"#f1f1f1",
																							}}
																							onChange={(
																								e
																							) => {
																								const selectedRuleType =
																									e
																										.target
																										.value;
																								setRuleType(
																									selectedRuleType
																								);
																								handlerule(
																									index,
																									fetchedIndex,
																									extIndex,
																									selectedRuleType,
																									0
																								);
																							}}
																						>
																							<option
																								value={
																									"Below"
																								}
																							>
																								Below
																							</option>
																							<option
																								value={
																									"Above"
																								}
																							>
																								Above
																							</option>
																						</select>
																						{ }
																					</td>
																				)}
																			{columns.includes(
																				"Rule"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						<select
																							style={{
																								background:
																									"#f1f1f1",
																							}}
																							onChange={(
																								e
																							) => {
																								const selectedValue =
																									parseFloat(
																										e
																											.target
																											.value
																									);
																								handlerule(
																									index,
																									fetchedIndex,
																									extIndex,
																									ruleType,
																									selectedValue
																								);
																							}}
																						>
																							<option
																								value={
																									0
																								}
																							>
																								Select
																							</option>
																							{ruleList.map(
																								(
																									d
																								) => (
																									<option
																										key={
																											d.value
																										}
																										value={
																											d.value
																										}
																									>
																										{
																											d.label
																										}
																									</option>
																								)
																							)}
																						</select>
																					</td>
																				)}
																			{columns.includes(
																				"Current CFP"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{
																							extendedItem.followingPrice
																						}
																					</td>
																				)}
																			{columns.includes(
																				"Variation from NBE"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{Math.round(
																							((extendedItem.followingPrice -
																								extendedItem.leadingPrice) *
																								100) /
																							extendedItem.leadingPrice
																						)}

																						%
																					</td>
																				)}
																			{columns.includes(
																				"Avg. Recommended CFP"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{extendedItem
																							?.recOverride
																							?.isEditable ? (
																							<input
																								type="text"
																								className="border border-[#BEBEBE] p-1 rounded-sm bg-[#F1F1F1]"
																								value={
																									extendedItem
																										.recOverride
																										.value
																								}
																								onChange={handleChange(
																									index,
																									fetchedIndex,
																									extIndex,
																									extendedItem
																										.recOverride
																										.value,
																									fetchedItem
																								)}
																							></input>
																						) : (
																							extendedItem
																								.recOverride
																								.value
																						)}
																					</td>
																				)}
																			{columns.includes(
																				"Avg. Recommended Price Change"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{extendedItem.AvgPriceChange !==
																							undefined
																							? `${numberFormatter(
																								extendedItem.AvgPriceChange
																							)}%`
																							: ""}
																					</td>
																				)}
																			{columns.includes(
																				"Loaded Opportunity($)"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						$
																						{numberFormatter(
																							extendedItem.opportunity
																						)}
																					</td>
																				)}
																			{columns.includes(
																				"Status"
																			) && (
																					<td
																						className="table-cell-text alignCenter"
																						style={
																							columnStyle
																						}
																					>
																						{extendedItem
																							?.recOverride
																							?.isEditable
																							? "AL"
																							: "AC"}
																					</td>
																				)}
																			{columns.includes(
																				"Actions"
																			) && (
																					<td
																						style={
																							columnStyle
																						}
																					>
																						<FontAwesomeIcon
																							icon={
																								faCheck
																							}
																							style={{
																								marginRight:
																									"2vh",
																								marginLeft:
																									"1.8vh",
																								height: "2.5vh",
																								padding:
																									"1%",
																							}}
																							className="acceptIcon"
																							onClick={() =>
																								handleAcceptClick(
																									index,
																									fetchedIndex,
																									extIndex
																								)
																							}
																							aria-hidden="true"
																						/>
																						<FontAwesomeIcon
																							icon={
																								faEdit
																							}
																							style={{
																								padding:
																									"1%",
																								height: "2.5vh",
																							}}
																							className="editIcon"
																							onClick={handleEditClick(
																								fetchedIndex,
																								extIndex,
																								index
																							)}
																						/>
																					</td>
																				)}
																		</tr>
																	)
																)}
														</>
													);
												}
											)}
									</>
								);
							})}
						</tbody>
					</table>
				</Col>
			</Row>
			<Row
				style={{ height: "11%", marginLeft: "0px", marginRight: "2vh" }}
			>
				<Col
					style={{ color: "black" }}
					className="flex flex-col "
					xs={24}
					sm={24}
					md={21}
				>
					<Row className=" ml-0 mr-0 p-[1vh]">
						<Pagination
							prev
							next
							first
							last
							ellipsis
							boundaryLinks
							maxButtons={5}
							size="xs"
							layout={["pager", "skip"]}
							total={50}
							limit={4}
							activePage={currentPage}
							onChangePage={handlePageChange}
						/>
					</Row>
					<Row className="text-[0.75vw] px-2">
						<p className="leading-[1] mb-[1vh]">
							<span className="font-bold">Actions: </span>
							<React.Fragment>
								<span>
									<span>Accept-</span>
									<FontAwesomeIcon
										icon={faCheck}
										style={{
											padding: "1%",
											marginRight: 0,
											fontSize: "0.6vw",
										}}
										className="acceptIcon"
										aria-hidden="true"
									/>
								</span>{" "}
								<span>
									<span>Modify-</span>
									<FontAwesomeIcon
										icon={faEdit}
										style={{
											padding: "1%",
											marginRight: 0,
											fontSize: "0.6vw",
										}}
										className="acceptIcon"
										aria-hidden="true"
									/>
								</span>
							</React.Fragment>
						</p>
						<p
							className="leading-[1]"
							style={{ color: "black", fontSize: "0.75vw" }}
						>
							<span className="font-bold">Status: </span>
							<span>
								AL - Autoloaded, AC - Accepted, NR - Needs to be
								reviewed, T - In-Tolerance
							</span>
						</p>
					</Row>
				</Col>
				<Col xs={24} sm={24} md={3} className="pr-2">
					<Button
						className="btn-text !bg-deloitteGreen w-[10vh] !text-white"
						onClick={() => handlefullaccept()}
					>
						Accept All
					</Button>
				</Col>
			</Row>
		</>
	);
};

export default DivisionTable;
